import React, { useState, useEffect } from "react";
import { Grid } from '@mui/material';

import Toolbar from '@mui/material/Toolbar';
import Card from "@mui/material/Card";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useParams } from 'react-router-dom';

import EditEventDialog from "./EditEventDialog";

import MDBoxRoot from './MDBox/MDBoxRoot';
import { SchoolTime } from "../utils/SchoolTime";

export default function AddEvent() {

  const { day } = useParams();
  const selectedDay = day?SchoolTime.fromISO(day+'T00:00:00'):null;

  const [valueTab, setValueTab] = useState('1');

  const navigate = useNavigate();

  function onEventUpdate(): void {
    navigate("..", { relative: "path" });
  }

  function onEventDelete(): void {
    navigate("..", { relative: "path" });
  }

  const defaultTime = selectedDay.addHours(12);
  const newEvent = { nodeId: '', id: -1, date: defaultTime.toISOLocal(), status: 0 /* scheduled  value */ };

  return (
    <Card>
      <MDBoxRoot
        component="main" px={4} py={4}
        sx={{ flexGrow: 1, width: '100%' }}
      >
        <Toolbar />

          <Grid item xs={9} sx={{ marginTop: "10px" }}>
            <TabContext value="1">
              <Tabs
                value="1"
                textColor="primary"
                aria-label="Edit Event"
              >
                <Tab label="Edit Event" value="1" />
                <Tab label="Attendees" value="2" disabled={true}/>
                <Tab label="Wait List" value="3" disabled={true}/>
                <Tab label="Instructors" value="4" disabled={true}/>
                <Tab label="Event Roster" value="5" disabled={true}/>
              </Tabs>
              <TabPanel value="1"><EditEventDialog event={newEvent} onSave={onEventUpdate} onDelete={onEventDelete} attendies={null} eventName=""/></TabPanel>
            </TabContext>
          </Grid>

      </MDBoxRoot>
    </Card>
  )
}



